import { pumaAPI, dataAPI } from "./api"
import { UserFormattingSettingsDTO } from "./models/fields"
import { IUserFormattingSettings } from "../components/applicationheader/components/usermenu"
import { ITenForceWindow } from "../global"

declare let window: ITenForceWindow

export const getHomePage = (): Promise<string> =>
    pumaAPI.getText("resources/homepageurl")

export const getUserFormattingSettings = (): Promise<IUserFormattingSettings> =>
    dataAPI
        .getJSON(
            "Users/Current()?$select=RegionalFormat&%24expand=RegionalFormat,TimeZone",
        )
        .then((settings: UserFormattingSettingsDTO) => {
            return {
                numberFormat: {
                    decimalSeparator:
                        settings?.RegionalFormat?.NumberFormat
                            ?.DecimalSeparator ??
                        window?.Sys?.CultureInfo?.CurrentCulture?.numberFormat
                            ?.NumberDecimalSeparator ??
                        ".",
                    groupSeparator:
                        settings?.RegionalFormat?.NumberFormat
                            ?.GroupSeparator ?? ",",
                    groupSizes: settings?.RegionalFormat?.NumberFormat
                        ?.GroupSizes ?? [3],
                    decimalDigits:
                        settings?.RegionalFormat?.NumberFormat?.DecimalDigits ??
                        3,
                },
                shortDatePattern:
                    settings?.RegionalFormat?.DateTimeFormat?.ShortDatePattern,
                shortTimeFormat:
                    settings?.RegionalFormat?.DateTimeFormat?.ShortTimePattern,
                timeZone: {
                    id: settings?.TimeZone?.Id,
                    label: settings?.TimeZone?.Label,
                    standardName: settings?.TimeZone?.StandardName,
                },
                isInitialized: true,
            }
        })
